'use strict';

var _classCallCheck = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _digest = require('./digest.js');

var from = function from(_ref) {
  var name = _ref.name,
      code = _ref.code,
      encode = _ref.encode;
  return new Hasher(name, code, encode);
};

var Hasher =
/*#__PURE__*/
function () {
  function Hasher(name, code, encode) {
    _classCallCheck(this, Hasher);

    this.name = name;
    this.code = code;
    this.encode = encode;
  }

  _createClass(Hasher, [{
    key: "digest",
    value: function digest(input) {
      var _this = this;

      if (input instanceof Uint8Array) {
        var result = this.encode(input);
        return result instanceof Uint8Array ? _digest.create(this.code, result) : result.then(function (digest$1) {
          return _digest.create(_this.code, digest$1);
        });
      } else {
        throw Error('Unknown type, must be binary type');
      }
    }
  }]);

  return Hasher;
}();

exports.Hasher = Hasher;
exports.from = from;